// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1bm6_"};